import { Button } from "../../Button/Button/Button";
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import styles from "./GDPRContent.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GDPRContent = function GDPRContent(_ref) {
  var agreeButtonText = _ref.agreeButtonText,
    disagreeButtonText = _ref.disagreeButtonText,
    disagreeButtonUrl = _ref.disagreeButtonUrl,
    _ref$headingText = _ref.headingText,
    headingText = _ref$headingText === void 0 ? '' : _ref$headingText,
    _ref$showHeadingText = _ref.showHeadingText,
    showHeadingText = _ref$showHeadingText === void 0 ? false : _ref$showHeadingText,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    bodyText = _ref.bodyText;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx("div", {
      className: styles.content,
      "data-e2e-name": "gdpr_content",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.textWrapper,
        children: [headingText && showHeadingText && /*#__PURE__*/_jsx(HeadingText, {
          align: "left",
          typog: "subhead2",
          ariaLevel: 2,
          className: styles.heading,
          children: headingText
        }), /*#__PURE__*/_jsx(Text, {
          childrenInline: true,
          typog: "bodycopyLarge",
          className: styles.bodyText,
          "data-e2e-name": "gdpr_body_text",
          children: bodyText
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.buttonsWrapper,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.disagreeButtonWrapper,
            children: /*#__PURE__*/_jsx(Button, {
              newWindow: true,
              type: "link",
              url: disagreeButtonUrl,
              className: styles.findMoreButton,
              "data-e2e-name": "gdpr_disagree_link",
              children: disagreeButtonText
            })
          }), /*#__PURE__*/_jsx("div", {
            className: styles.agreeButtonWrapper,
            "data-e2e-name": "gdpr_agree_button",
            children: /*#__PURE__*/_jsx(Button, {
              type: "secondary",
              size: "small",
              onClick: onClose,
              children: agreeButtonText
            })
          })]
        })]
      })
    })
  });
};